import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return <Sonner className={"persian-font toaster group"} {...props} />;
};

export { Toaster };
